module.exports = __webpack_public_path__ + "static/media/search.f3c1a82b.svg";